import { Pipe, PipeTransform } from '@angular/core';
import { TranslationsService } from '../services/translations/translations.service';
import Translation, { AVAILABLE_TRANSLATIONS } from '../../assets/strings/translations';

@Pipe({
  name: 'translation'
})
export class TranslationPipe implements PipeTransform {

  constructor(private readonly translationsService: TranslationsService) {
  }
  async transform(value: any, ...args: any[]) {
    if (value != null) {
      const currentCountry = this.translationsService.currentCountry;
      const translationValue = Translation.getTranslationFile(currentCountry)[value];
      if (translationValue != null) {
        return translationValue;
      }
      return Translation.getTranslationFile(AVAILABLE_TRANSLATIONS.COL)[value];
    }
    return null;
  }

}
